import React, { useState } from 'react';
import { motion } from 'framer-motion';
import BasicRegistrationForm from '../components/forms/BasicRegistrationForm';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const ApplyNowPage = () => {
  const [isFormOpen, setIsFormOpen] = useState(true);
  const navigate = useNavigate();

  const handleCloseForm = () => {
    setIsFormOpen(false);
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-highlight flex items-center justify-center p-4">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, var(--color-secondary) 1px, transparent 0)`,
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      {/* Back Button */}
      <motion.button
        onClick={() => navigate('/')}
        className="fixed top-8 left-8 z-40 bg-white shadow-lg rounded-full p-3 hover:shadow-xl transition-shadow"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <FaArrowLeft className="text-primary" />
      </motion.button>

      {/* Main Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-8"
        >
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-primary mb-4">
            Begin Your Investment Journey
          </h1>
          <p className="text-xl text-accent-dark max-w-3xl mx-auto">
            Take the first step towards wealth management excellence with Segway Capital. 
            Complete your application to access our exclusive investment opportunities.
          </p>
        </motion.div>

        {/* Features Grid */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="grid md:grid-cols-3 gap-8 mb-12"
        >
          <div className="bg-white rounded-xl p-6 shadow-lg">
            <div className="w-12 h-12 bg-secondary rounded-full flex items-center justify-center mb-4">
              <span className="text-white font-bold">1</span>
            </div>
            <h3 className="text-lg font-semibold text-primary mb-2">Quick Application</h3>
            <p className="text-gray-600">
              Submit your basic information in under 5 minutes to begin the process.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-lg">
            <div className="w-12 h-12 bg-secondary rounded-full flex items-center justify-center mb-4">
              <span className="text-white font-bold">2</span>
            </div>
            <h3 className="text-lg font-semibold text-primary mb-2">Email Verification</h3>
            <p className="text-gray-600">
              Receive a secure link to complete your full registration and verification.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-lg">
            <div className="w-12 h-12 bg-secondary rounded-full flex items-center justify-center mb-4">
              <span className="text-white font-bold">3</span>
            </div>
            <h3 className="text-lg font-semibold text-primary mb-2">Start Investing</h3>
            <p className="text-gray-600">
              Access your personalized dashboard and begin your investment journey.
            </p>
          </div>
        </motion.div>

        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-center bg-white rounded-xl p-8 shadow-lg"
        >
          <h2 className="text-2xl font-heading font-bold text-primary mb-4">
            Ready to Get Started?
          </h2>
          <p className="text-gray-600 mb-6">
            Join thousands of investors who trust Segway Capital with their wealth management needs.
          </p>
          <motion.button
            onClick={() => setIsFormOpen(true)}
            className="bg-gradient-to-r from-secondary to-secondary-dark text-white px-8 py-3 rounded-lg font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-200"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Start Your Application
          </motion.button>
        </motion.div>
      </div>

      {/* Registration Form Modal */}
      <BasicRegistrationForm 
        isOpen={isFormOpen}
        onClose={handleCloseForm}
      />
    </div>
  );
};

export default ApplyNowPage; 